const angular = require('angular');

const bannersService = require('./banners.service'),
    { bannerComponentDefinition } = require('./banner.component');

angular.module('wowApp.shop')
    .service('BannersService', bannersService)
    .component('wowBanner', bannerComponentDefinition);



// WEBPACK FOOTER //
// ./src/shop/banners/index.js